import {
  Box,
  Grid,
  Tab,
  Tabs,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Badge,
  Button,
  TextField,
  useStepContext,
} from "@mui/material";
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker,
//   InfoWindow,
//   Polyline,
// } from "react-google-maps";

import {
  ArrowDropDownCircleOutlined,
  NotificationsOutlined,
} from "@material-ui/icons";
import { useContext, useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";

import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import AppContext from "../../context/AppContext";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { each, setOptions } from "highcharts";
import axios from "axios";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Popover,
} from "@mui/material";
import { GoogleMap, LoadScript, Marker, InfoWindow, Polyline, useLoadScript, useJsApiLoader } from '@react-google-maps/api';

import AddBeacons from "../AddBeacons";
import UnidentifiedData from "./UnidentifiedData";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const cleanCoordinates = (coordinates) => {
  if (coordinates.length > 1) {
    const cleanedCoords = [];
    for (let i = 0; i < coordinates.length; i++) {
      if (
        i === 0 ||
        coordinates[i].lat !== coordinates[i - 1].lat ||
        coordinates[i].lng !== coordinates[i - 1].lng
      ) {
        cleanedCoords.push(coordinates[i]);
      }
    }
    return cleanedCoords;
  }
  return coordinates;
};

const MyMapComponent = (props) => {

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY
  });
  const [selectedMarker, setSelectedMarker] = useState(null);
  const pathCoordinates = cleanCoordinates(props.pathCoordinates);
  if (loadError) {
    console.error("Error loading Google Maps API:", loadError);
    return <div>Error loading map</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }
  if (isLoaded) {
    return (

      <GoogleMap
        // defaultZoom={14}  
        // defaultCenter={{ lat: props.latitude, lng: props.longitude }}
        mapContainerStyle={{
          width: '100%',
          height: '400px'
        }}
        center={{ lat: props.latitude, lng: props.longitude }}
        zoom={14}
      >
        <Marker
          position={{ lat: props.latitude, lng: props.longitude }}
          onClick={() =>
            setSelectedMarker({
              lat: props.latitude,
              lng: props.longitude,
            })
          }
        />

        {selectedMarker && (
          <InfoWindow
            position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div>
              <p>Latitude: {selectedMarker.lat}</p>
              <p>Longitude: {selectedMarker.lng}</p>
              <p>Device_id: {props.device_id}</p>
              <p>Timestamp: {props.timestamp}</p>
            </div>
          </InfoWindow>
        )}

        {pathCoordinates && pathCoordinates.length > 0 && (
          <Polyline
            path={pathCoordinates}
            options={{
              strokeColor: "#9027ed82",
              strokeOpacity: 1.0,
              strokeWeight: 2,
            }}
          />
        )}
      </GoogleMap>
    );
  }

  else {
    return <div>Loading</div>
  }

  // return (

  //   <GoogleMap
  //     // defaultZoom={14}  
  //     // defaultCenter={{ lat: props.latitude, lng: props.longitude }}
  //     center={{ lat: props.latitude, lng: props.longitude }}
  //     zoom={10}
  //   >
  //     <Marker
  //       position={{ lat: props.latitude, lng: props.longitude }}
  //       onClick={() =>
  //         setSelectedMarker({
  //           lat: props.latitude,
  //           lng: props.longitude,
  //         })
  //       }
  //     />

  //     {selectedMarker && (
  //       <InfoWindow
  //         position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
  //         onCloseClick={() => setSelectedMarker(null)}
  //       >
  //         <div>
  //           <p>Latitude: {selectedMarker.lat}</p>
  //           <p>Longitude: {selectedMarker.lng}</p>
  //           <p>Device_id: {props.device_id}</p>
  //           <p>Timestamp: {props.timestamp}</p>
  //         </div>
  //       </InfoWindow>
  //     )}

  //     {pathCoordinates && pathCoordinates.length > 0 && (
  //       <Polyline
  //         path={pathCoordinates}
  //         options={{
  //           strokeColor: "#9027ed82",
  //           strokeOpacity: 1.0,
  //           strokeWeight: 2,
  //         }}
  //       />
  //     )}
  //   </GoogleMap>
  // );
};

// const MyMapComponent = withScriptjs(
//   withGoogleMap((props) => {
//     const [selectedMarker, setSelectedMarker] = useState(null);
//     const pathCoordinates = cleanCoordinates(props.pathCoordinates);
//     console.log({pathCoordinates});
//     return (
//       <GoogleMap
//         defaultZoom={14}
//         defaultCenter={{ lat: props.latitude, lng: props.longitude }}
//       >
//         <Marker
//           position={{ lat: props.latitude, lng: props.longitude }}
//           onClick={() =>
//             setSelectedMarker({
//               lat: props.latitude,
//               lng: props.longitude,
//             })
//           }
//           // on={() => setSelectedMarker(null)}
//         />

//         {selectedMarker && (
//           <InfoWindow
//             position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
//             onCloseClick={() => setSelectedMarker(null)}
//           >
//             <div>
//               <p>Latitude: {selectedMarker.lat}</p>
//               <p>Longitude: {selectedMarker.lng}</p>
//               <p>Device_id: {props.device_id}</p>
//               <p>Timestamp: {props.timestamp}</p>
//             </div>
//           </InfoWindow>
//         )}

//         {pathCoordinates && pathCoordinates.length > 0 && (
//           <Polyline
//             path={pathCoordinates}
//             options={{
//               strokeColor: "#9027ed82",
//               strokeOpacity: 1.0,
//               strokeWeight: 2,
//             }}
//           />
//         )}
//       </GoogleMap>
//     );
//   })
// );

const styles = ({ spacing, transitions, breakpoints, palette, shape }) => ({
  popover: {
    padding: spacing(2),
    maxWidth: 300,
    bottom: spacing(300),
    backgroundColor: "#f9f9f9",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
  },
  popoverTitle: {
    fontWeight: 700,
    marginBottom: spacing(1),
    color: "#333",
  },
  popoverContent: {
    fontSize: "0.875rem",
    color: "#555",
  },
});

const GatewayDetails = ({ classes }) => {
  const { category, asset, gateway, socketData } = useContext(AppContext);
  const { gateway_id } = useParams();
  const [interval, setInterval] = useState("hour");
  const [gateway_connected, setGatewayConnected] = useState([]);
  const [distance, setDistance] = useState("rssi");
  const [latestGateway, setLatestGateway] = useState({
    id: "",
    lat: "",
    long: "",
    device_id: "",
    timestamp: "",
  });
  const currentDate = new Date();
  const oneDayBefore = new Date(currentDate);
  oneDayBefore.setHours(currentDate.getHours() - 1);
  let localStartTime = new Date(
    oneDayBefore.getTime() - oneDayBefore.getTimezoneOffset() * 60000
  );
  let localEndTime = new Date(
    currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
  );
  const [searchData, setSeearchData] = useState(null);
  const [dateRange, setDateRange] = useState({
    start: localStartTime,
    end: localEndTime,
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let formattedStartTime = dateRange.start
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        let formattedEndTime = dateRange.end
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        // formattedStartTime = subtractTime(formattedStartTime, 5, 30);
        // formattedEndTime = subtractTime(formattedEndTime, 5, 30);

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/gateway-lat-lon/map`,
          {
            device_id: gateway_id,
            start_time: formattedStartTime,
            end_time: formattedEndTime,
          }
        );

        if (response.data.status == "success")
          setSeearchData(response.data.gateway_logs);
      } catch (error) {
        console.error("Error fetching map details:", error);
      }
    };

    fetchData();
  }, [dateRange]);

  const handleChange = (event) => {
    setInterval(event.target.value);
  };

  let gateway_details = gateway.filter(
    (data) => data.mac_address === gateway_id
  );

  let Socketdata = socketData.filter((data) => data.device_id == gateway_id);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleBadgeClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [value, setValue] = useState(0);
  const [data, setData] = useState([]);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeDistance = (event) => {
    setDistance(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/gateway/find`,
          {
            intervals: interval,
            gateway_id: gateway_id,
            distance: distance,
          }
        );
        if (response.data.success == true) {
          setData(response.data.data);
          setGatewayConnected(response.data.gateway_connected);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [interval, distance]);

  const options = {
    series: Object.keys(data).map((each) => ({
      name: each,
      data: data[each].map((item) => [
        new Date(item.ts).getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000,
        Number(item.rssi),
      ]),
    })),
    chart: {
      type: "scatter",
      zooming: {
        type: "xy",
      },
    },
    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      align: "left",
    },

    xAxis: {
      type: "datetime",
      title: {
        text: "Timestamp",
      },
    },
    yAxis: {
      title: {
        text: distance == "rssi" ? "RSSI" : "Distance",
      },
      labels: {
        format: distance == "rssi" ? "{value}" : "{value} m",
      },
    },
    legend: {
      enabled: true,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 2.5,
          symbol: "circle",
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        },
        jitter: {
          x: 0.005,
        },
      },
      setOptions: {
        colors: [
          "rgba(5,141,199,0.5)",
          "rgba(80,180,50,0.5)",
          "rgba(237,86,27,0.5)",
        ],
      },
    },
    tooltip: {
      formatter: function () {
        let valueLabel;
        if (distance === "rssi") {
          valueLabel = `RSSI: ${this.y}`;
        } else {
          valueLabel = `Distance: ${this.y} m`;
        }
        return `<b>${this.series.name
          }</b><br/>Timestamp: ${Highcharts.dateFormat(
            "%Y-%m-%d %H:%M:%S",
            this.x
          )}<br/>${valueLabel}`;
      },
    },
  };

  const columns = [
    {
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "mac",
      headerName: "MAC ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"MAC Address "}</strong>
      ),
    },
    {
      field: "rssi",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Distance"}</strong>
      ),
    },
    {
      field: "ts",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Timestamp"}</strong>
      ),
    },
    {
      field: "assetName",
      headerName: "assetName",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Asset Name"}</strong>
      ),
    },
    {
      field: "assetCategory",
      headerName: "assetCategory",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Asset Category"}
        </strong>
      ),
    },
  ];

  const [gatewayLogs, setGatewayLogs] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  useEffect(() => {
    const fetchGatewayLogs = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/gateway_logs/device?device_id=${gateway_id}&page=${paginationModel.page + 1
          }&page_size=${paginationModel.pageSize}`
        );
        if (response.data.status == "success") {
          setGatewayLogs(response.data.gateway_logs);
          setTotalRows(response.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching gateway logs:", error);
      }
    };

    fetchGatewayLogs();
  }, [paginationModel]);
  const columnns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      headerAlign: "center",
      align: "center",

      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Timestamp"}</strong>
      ),
    },
    {
      field: "lat",
      headerName: "Latitude",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Latitude"}</strong>
      ),
    },
    {
      field: "lon",
      headerName: "Longitude",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Longitude"}</strong>
      ),
    },
    {
      field: "supply_voltage",
      headerName: "Supply Voltage",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Supply Voltage"}
        </strong>
      ),
    },
    // {
    //   field: "battery_voltage",
    //   headerName: "Battery Voltage",
    //   width: 150,
    //   headerAlign: "center",
    //   align: "center",
    // },
    {
      field: "gsm_rssi",
      headerName: "GSM RSSI",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"GSM RSSI"}</strong>
      ),
    },
  ];

  useEffect(() => {
    // setInterval(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/gateway/coordinates?device_id=${gateway_id}`
        );
        if (response.data.status == "success") {
          setLatestGateway({
            id: response.data.data.id,
            lat: response.data.data.lat,
            long: response.data.data.long,
            device_id: response.data.data.device_id,
            timestamp: response.data.data.timestamp,
          });
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
    // }, 1000);
  }, []);




  return (
    <Grid container>
      <Grid
        container
        style={{
          boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.2)",
          borderRadius: 13,
          padding: 25,
          alignItems: "center",
          justifyContent: isMobile ? "flex-start" : "space-evenly",
        }}
      >
        {/* <Grid item xs={2} style={{ fontFamily: 'sans-serif', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}> */}
        {/* <img style={{ width: 80, height: 80 }} src={assetDetails.asset_category == 'Bag' ? "/images/Bag.png" : assetDetails.asset_category == 'Trolley' ? "/images/Trolley.png" : "/images/Laptop.png"} /> */}
        {/* <Typography style={{ fontWeight: 500, fontSize: '14px', color: '#60636C' }}>Gateway Position: <span style={{ fontWeight: 500, color: "#1976d2", fontSize: '15px' }}>{gateway_details.length ? gateway_details[0].position: ''}</span></Typography> */}
        {/* </Grid> */}
        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
              justifyContent: isMobile ? "flex-start" : "center",
            }}
          >
            Gateway Id:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {gateway_details.length ? gateway_details[0].id : ""}
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={12} md={2} style={{ fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              justifyContent: isMobile ? "flex-start" : "center",
              color: "#60636C",
            }}
          >
            Gateway Location:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {gateway_details.length && gateway_details[0].location.length
                ? gateway_details[0].location[0].name
                : ""}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
              justifyContent: isMobile ? "flex-start" : "center",
            }}
          >
            Gateway Position:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {gateway_details.length ? gateway_details[0].position : ""}
            </Typography>
          </Typography>
        </Grid>

        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
              justifyContent: isMobile ? "flex-start" : "center",
            }}
          >
            Gateway IMEI: {" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {gateway_details.length ? gateway_details[0].mac_address : ""}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
              justifyContent: isMobile ? "flex-start" : "center"
            }}
          >
            Gateway Creation Time{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                fontSize: "15px",
              }}
            >
              {gateway_details.length
                ? new Date(gateway_details[0].created_at).toLocaleString()
                : ""}
            </Typography>
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={11}>
        <Box sx={{ width: "100%" }}>
          <Box>
            {
              gateway_details.length && gateway_details[0].make == 'Moko' ? <Tabs
                value={value}
                onChange={handleChangeTab}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#07689f",
                  },
                }}
              >

                <Tab label="Visualisation" {...a11yProps(0)} />
                <Tab label="Logs" {...a11yProps(1)} />
                <Tab label="Unregistered Beacons" {...a11yProps(2)} />
              </Tabs> : <Tabs
                value={value}
                onChange={handleChangeTab}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#07689f",
                  },
                }}
                variant="scrollable"
                scrollButtons="on"
              >

                <Tab label="Visualisation" {...a11yProps(0)} />
                <Tab label="map" {...a11yProps(1)} />
                <Tab label="Logs" {...a11yProps(2)} />
                <Tab label="Unregistered Beacons" {...a11yProps(3)} />
              </Tabs>
            }

          </Box>

          {
            gateway_details.length && gateway_details[0].make == 'Moko' ? <>
              <CustomTabPanel value={value} index={0}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Interval Size
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={interval}
                        label="Interval Size"
                        style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                        onChange={handleChange}
                      >
                        <MenuItem value="second">second</MenuItem>
                        <MenuItem value="minute">minutes</MenuItem>
                        <MenuItem value="hour">hour</MenuItem>
                        <MenuItem value="day">day</MenuItem>
                        <MenuItem value="week">week</MenuItem>
                        <MenuItem value="month">month</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Distance
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={distance}
                        label="Interval Size"
                        style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                        onChange={handleChangeDistance}
                      >
                        <MenuItem value="rssi">RSSI</MenuItem>
                        <MenuItem value="metre">Metre</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* <Grid
                  item
                  xs={4}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Badge
                    badgeContent={Object.keys(Socketdata).length === 0 ? 0 : 1}
                    color="primary"
                    onClick={handleBadgeClick}
                  >
                    <NotificationsOutlined color="action" />
                  </Badge>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={
                      {
                        // vertical: 'bottom',
                        // horizontal: 'left',
                      }
                    }
                  >
                    <Box className={classes.popover}>
                      <Typography variant="h6" className={classes.popoverTitle}>
                        Unauthorized Beacon Request
                      </Typography>
                      {Socketdata.length > 0 ? (
                        Socketdata.map((obj, index) => {
                          obj.ts = new Date(
                            new Date(obj.ts).getTime()
                          ).toLocaleString();
                          return (
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ArrowDropDownCircleOutlined />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                              >
                                <Typography
                                  variant="subtitle1"
                                  className={classes.popoverContent}
                                  noWrap
                                  key={index}
                                >
                                  <span>{obj.mac}</span>
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                {Object.keys(obj).map((obje) => (
                                  <Typography
                                    className={classes.popoverContent}
                                    noWrap
                                    key={obj}
                                  >
                                    {obje != "device_id" && (
                                      <>
                                        {" "}
                                        <span>{obje} : </span>
                                        <span>{obj[obje]}</span>{" "}
                                      </>
                                    )}
                                  </Typography>
                                ))}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <AddBeacons
                                    val="Link"
                                    mac={obj.mac}
                                    link={handleLink}
                                  />
                                  <AddBeacons
                                    val="Link Existing"
                                    mac={obj.mac}
                                    link={handleLinkAttach}
                                  />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          );
                        })
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={classes.popoverContent}
                          noWrap
                        >
                          No Content
                        </Typography>
                      )}
                    </Box>
                  </Popover>
                </Grid> */}
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: 500,
                        color: "#1976d2",
                        padding: "10px 0px",
                      }}
                    >
                      Assets Connected
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {Object.keys(data).length > 0 ? (
                      <HighchartsReact highcharts={Highcharts} options={options} />
                    ) : (
                      <p>No data available</p>
                    )}
                  </Grid>
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                {/* <Grid item xs={12} style={{ height: 500 }}>
                <DataGrid
                  getRowId={(row) => row.id}
                  rows={gatewayLogs}
                  columns={columnns}
                  rowCount={totalRows}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  paginationMode="server"
                  density="compact"
                  components={{ Toolbar: GridToolbar }}
                />
              </Grid> */}
                <Grid item xs={12} style={{ height: 500 }}>
                  <DataGrid
                    getRowId={(row) => row.ts}
                    rows={gateway_connected}
                    columns={columns}
                    pageSize={10}
                    rowSelection={false}
                    rowsPerPageOptions={[10, 20, 30]}
                    density="compact"
                    components={{
                      Toolbar: GridToolbar,
                      FilterPanel: GridFilterPanel,
                    }}
                    slotProps={{
                      filterPanel: {
                        sx: {
                          width: "100%",          // full width responsive
                          maxWidth: "100%",
                          padding: "10px",
                          "& .MuiDataGrid-filterForm": {
                            flexDirection: "column",
                            gap: "10px",
                          },
                        },
                      },
                    }}
                    pagination
                  />
                </Grid>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={2}>
                <UnidentifiedData gateway_id={gateway_id} />
              </CustomTabPanel></> : <>
              <CustomTabPanel value={value} index={0}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Interval Size
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={interval}
                        label="Interval Size"
                        style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                        onChange={handleChange}
                      >
                        <MenuItem value="second">second</MenuItem>
                        <MenuItem value="minute">minutes</MenuItem>
                        <MenuItem value="hour">hour</MenuItem>
                        <MenuItem value="day">day</MenuItem>
                        <MenuItem value="week">week</MenuItem>
                        <MenuItem value="month">month</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Distance
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={distance}
                        label="Interval Size"
                        style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                        onChange={handleChangeDistance}
                      >
                        <MenuItem value="rssi">RSSI</MenuItem>
                        <MenuItem value="metre">Metre</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* <Grid
                item
                xs={4}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Badge
                  badgeContent={Object.keys(Socketdata).length === 0 ? 0 : 1}
                  color="primary"
                  onClick={handleBadgeClick}
                >
                  <NotificationsOutlined color="action" />
                </Badge>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={
                    {
                      // vertical: 'bottom',
                      // horizontal: 'left',
                    }
                  }
                >
                  <Box className={classes.popover}>
                    <Typography variant="h6" className={classes.popoverTitle}>
                      Unauthorized Beacon Request
                    </Typography>
                    {Socketdata.length > 0 ? (
                      Socketdata.map((obj, index) => {
                        obj.ts = new Date(
                          new Date(obj.ts).getTime()
                        ).toLocaleString();
                        return (
                          <Accordion>
                            <AccordionSummary
                              expandIcon={<ArrowDropDownCircleOutlined />}
                              aria-controls="panel2-content"
                              id="panel2-header"
                            >
                              <Typography
                                variant="subtitle1"
                                className={classes.popoverContent}
                                noWrap
                                key={index}
                              >
                                <span>{obj.mac}</span>
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              {Object.keys(obj).map((obje) => (
                                <Typography
                                  className={classes.popoverContent}
                                  noWrap
                                  key={obj}
                                >
                                  {obje != "device_id" && (
                                    <>
                                      {" "}
                                      <span>{obje} : </span>
                                      <span>{obj[obje]}</span>{" "}
                                    </>
                                  )}
                                </Typography>
                              ))}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <AddBeacons
                                  val="Link"
                                  mac={obj.mac}
                                  link={handleLink}
                                />
                                <AddBeacons
                                  val="Link Existing"
                                  mac={obj.mac}
                                  link={handleLinkAttach}
                                />
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })
                    ) : (
                      <Typography
                        variant="subtitle1"
                        className={classes.popoverContent}
                        noWrap
                      >
                        No Content
                      </Typography>
                    )}
                  </Box>
                </Popover>
              </Grid> */}
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: 500,
                        color: "#1976d2",
                        padding: "10px 0px",
                      }}
                    >
                      Assets Connected
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {Object.keys(data).length > 0 ? (
                      <HighchartsReact highcharts={Highcharts} options={options} />
                    ) : (
                      <p>No data available</p>
                    )}
                  </Grid>
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <Grid item xs={12} style={{ height: 500 }}>
                  <DataGrid
                    getRowId={(row) => row.id}
                    rows={gatewayLogs}
                    columns={columnns}
                    rowCount={totalRows}
                    rowSelection={false}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    paginationMode="server"
                    density="compact"
                    components={{
                      Toolbar: GridToolbar,
                      FilterPanel: GridFilterPanel,
                    }}
                    slotProps={{
                      filterPanel: {
                        sx: {
                          width: "100%",          // full width responsive
                          maxWidth: "100%",
                          padding: "10px",
                          "& .MuiDataGrid-filterForm": {
                            flexDirection: "column",
                            gap: "10px",
                          },
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} style={{ height: 500 }}>
                  <DataGrid
                    getRowId={(row) => row.ts}
                    rows={gateway_connected}
                    columns={columns}
                    pageSize={10}
                    rowSelection={false}
                    rowsPerPageOptions={[10, 20, 30]}
                    density="compact"
                    components={{
                      Toolbar: GridToolbar,
                      FilterPanel: GridFilterPanel,
                    }}
                    slotProps={{
                      filterPanel: {
                        sx: {
                          width: "100%",          // full width responsive
                          maxWidth: "100%",
                          padding: "10px",
                          "& .MuiDataGrid-filterForm": {
                            flexDirection: "column",
                            gap: "10px",
                          },
                        },
                      },
                    }}
                    pagination
                  />
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Grid item xs={12} style={{ height: 500 }}>
                  <TextField
                    label="Start Time"
                    type="datetime-local"
                    value={dateRange.start.toISOString().slice(0, 16)}
                    onChange={
                      (e) => {
                        let currentTime = new Date(e.target.value);
                        let localTime = new Date(
                          currentTime.getTime() -
                          currentTime.getTimezoneOffset() * 60000
                        );
                        setDateRange({ ...dateRange, start: localTime });
                      }
                      // setDateRange({ ...dateRange, start: new Date(e.target.value) })
                    }
                    InputLabelProps={{
                      shrink: true,
                      style: {
                        fontWeight: 700,
                        color: "#005778",
                        fontSize: 15,
                      },
                    }}
                    InputProps={{
                      style: {
                        fontSize: 14,
                        color: "rgba( 0, 0, 0, 70% )",
                        height: 40,
                      },
                    }}
                    style={{ width: isMobile ? "100%" : "40%", marginRight: 30, marginBottom: 30 }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#50C1E9",
                        },
                        "&:hover fieldset": {
                          borderColor: "#50C1E9",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#50C1E9",
                        },
                      },
                    }}
                  />
                  <TextField
                    label="End Time"
                    type="datetime-local"
                    value={dateRange.end.toISOString().slice(0, 16)}
                    onChange={
                      (e) => {
                        let currentTime = new Date(e.target.value);
                        let localTime = new Date(
                          currentTime.getTime() -
                          currentTime.getTimezoneOffset() * 60000
                        );
                        setDateRange({ ...dateRange, end: localTime });
                      }
                      // setDateRange({ ...dateRange, end: new Date(e.target.value) })
                    }
                    InputLabelProps={{
                      shrink: true,
                      style: {
                        fontWeight: 700,
                        color: "#005778",
                        fontSize: 15,
                      },
                    }}
                    InputProps={{
                      style: {
                        fontSize: 14,
                        color: "rgba( 0, 0, 0, 70% )",
                        height: 40,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#50C1E9",
                        },
                        "&:hover fieldset": {
                          borderColor: "#50C1E9",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#50C1E9",
                        },
                      },
                    }}
                    style={{ width: isMobile ? "100%" : "40%", marginRight: 30 }}
                  />
                  {/* <MyMapComponent
                latitude={latestGateway.lat}
                longitude={latestGateway.long}
                device_id={gateway_id}
                timestamp={latestGateway.timestamp}
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                pathCoordinates={searchData}
              /> */}
                  {latestGateway && searchData && searchData.length > 0 ? (
                    <MyMapComponent
                      latitude={latestGateway?.lat || 0} // Fallback to 0 or a default value
                      longitude={latestGateway?.long || 0}
                      device_id={gateway_id || 'N/A'} // Fallback if no gateway ID
                      timestamp={latestGateway?.timestamp || 'No Data'}
                      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `400px` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                      pathCoordinates={searchData}
                    />
                  ) : (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      <p>No Data Available</p>
                    </div>
                  )}

                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={3}>
                <UnidentifiedData gateway_id={gateway_id} />
              </CustomTabPanel></>}

        </Box>
      </Grid>
      <Grid
        item
        xs={1}
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}
      >
        <Badge
          badgeContent={Object.keys(Socketdata).length === 0 ? 0 : 1}
          color="primary"
          onClick={handleBadgeClick}
        >
          <NotificationsOutlined color="action" />
        </Badge>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={
            {
              // vertical: 'bottom',
              // horizontal: 'left',
            }
          }
        >
          <Box className={classes.popover}>
            <Typography variant="h6" className={classes.popoverTitle}>
              Unauthorized Beacon Request
            </Typography>
            {Socketdata.length > 0 ? (
              Socketdata.map((obj, index) => {
                obj.ts = new Date(new Date(obj.ts).getTime()).toLocaleString();
                return (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ArrowDropDownCircleOutlined />}
                      aria-controls="panel2-content"
                      id="panel2-header"
                    >
                      <Typography
                        variant="subtitle1"
                        className={classes.popoverContent}
                        noWrap
                        key={index}
                      >
                        <span>{obj.mac}</span>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {Object.keys(obj).map((obje) => (
                        <Typography
                          className={classes.popoverContent}
                          noWrap
                          key={obj}
                        >
                          {obje != "device_id" && (
                            <>
                              {" "}
                              <span>{obje} : </span>
                              <span>{obj[obje]}</span>{" "}
                            </>
                          )}
                        </Typography>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Typography
                variant="subtitle1"
                className={classes.popoverContent}
                noWrap
              >
                No Content
              </Typography>
            )}
          </Box>
        </Popover>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(GatewayDetails);
